angular.module("vgresiduos").factory("additionalPropertyUtilService", [
	"$rootScope",
	"dialogService",
	"$sce",
	function () {
		"use strict";

		const _buildAdditionalPropertiesFromPopupToGrid = function (additionalInfo) {
			const gridInformation = {
				Id: additionalInfo.Id ? additionalInfo.Id : Vgr.util.uuid(),
				PropertyId: additionalInfo.Property.id,
				PropertyName: additionalInfo.Property.name,
				PropertyType: additionalInfo.Property.type,
				cantDelete: additionalInfo.Property.cantDelete
			};

			if (additionalInfo.Property.type == Vgr.enumerations.additionalProperty.type.SuspendList) {
				gridInformation.InfoValue = additionalInfo.PropertyValue.name;
				gridInformation.InfoValueId = additionalInfo.PropertyValue.id;
			} else {
				gridInformation.InfoValue = additionalInfo.PropertyValue;
			}

			return gridInformation;
		};

		const _buildInformationsToGridFromApiV2EntityInformation = function (informations) {
			const gridInformations = [];

			for (const information of informations) {
				gridInformations.push({
					Id: information.Id,
					PropertyId: information.Property.Id,
					PropertyName: information.Property.Name,
					PropertyType: information.Property.Type,
					InfoValue: information.Value,
					InfoValueId: information.ValueId,
					cantDelete: information.Property.cantDelete
				});
			}

			return gridInformations;
		};

		const _buildInformationToGridFromApiCoreAdditionalProperty = function (property, cantDelete) {
			return {
				Id: Vgr.util.uuid(),
				PropertyId: property.id,
				PropertyName: property.name,
				InfoValue: null,
				InfoValueId: null,
				cantDelete: cantDelete
			};
		};

		const _buildAdditionalPropertiesFromGridToRequest = function (gridInformations) {
			const informations = [];

			if (gridInformations) {
				for (const gridInformation of gridInformations) {
					informations.push({
						Id: gridInformation.Id,
						Property: gridInformation.PropertyId ? gridInformation.PropertyId : gridInformation.PropertyName,
						Value: gridInformation.InfoValueId ? gridInformation.InfoValueId : gridInformation.InfoValue
					});
				}
			}

			return informations;
		};

		return {
			buildInformationsToGridFromApiV2EntityInformation: _buildInformationsToGridFromApiV2EntityInformation,
			buildInformationToGridFromApiCoreAdditionalProperty: _buildInformationToGridFromApiCoreAdditionalProperty,
			buildAdditionalPropertiesFromPopupToGrid: _buildAdditionalPropertiesFromPopupToGrid,
			buildAdditionalPropertiesFromGridToRequest: _buildAdditionalPropertiesFromGridToRequest
		};
	}
]);
